import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagRecalculoCostosFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='flagRecalculoCostos'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagRecalculoCostos'
              label='Recalculo costos'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagRecalculoCostosFormGroup)
